import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

export default function boxSliderScript() {

  const boxSliders = document.querySelectorAll('.c-boxes-slider');

  if (!boxSliders) {
    return;
  }  

  boxSliders.forEach((boxSlider) => {
    const slider = boxSlider.querySelector('.swiper');
    const nextButton = boxSlider.querySelector('.swiper-button-next');
    const prevButton = boxSlider.querySelector('.swiper-button-prev');
    const swiperBoxes = new Swiper(slider, {
      modules: [Navigation],
      centeredSlides: true,
      slidesPerView: 1,
      initialSlide: 1,
      loop: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
    });
  });
  
}

